
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/manage-tracking",
      function () {
        return require("private-next-pages/manage-tracking.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/manage-tracking"])
      });
    }
  